import React from 'react';
import Page from '../components/Page';

const Sobre = (props) => {
   return(
      <Page view="sobre" bg="/assets/img/sobre-bg.jpg">
         <h1>Sobre</h1>
         <p>Todo profissional que atua na linha de frente no setor saúde, no enfrentamento da pandemia da COVID-19, deve se sentir seguro no ambiente de trabalho. Estes ambientes devem adotar medidas de proteção garantindo a saúde dos trabalhadores e oferecer condições para a não sobrecarga de trabalho, além de suporte psicológico dada a exposição a situações de vulnerabilidade emocional e estresse ocupacional.</p>
         <h3>Público-alvo</h3>
         <p>Profissionais atuando na linha de frente do setor saúde no enfrentamento da COVID-19 nas redes pública e privada no Brasil, além disso a população em geral.</p>
         <h3>Qual o problema a ser resolvido</h3>
         <p>Elevado acometimento de profissionais do setor saúde no contexto da pandemia da COVID-19 causada pelo novo coronavírus SARS-CoV-2</p>
         <h3>Potenciais benefícios para saúde</h3>
         <p>Nossa plataforma visa identificar potenciais riscos e dar visibilidade à vulnerabilidade a que têm sido expostos profissionais do setor saúde atuando na linha de frente. Esta iniciativa permitirá o levantamento e mapeamento destas exposições, permitindo o direcionamento de práticas de profilaxia e de prevenção apoiando as autoridades e gestores de saúde na tomada de decisão visando melhor preparo diante de exposições do público alvo.</p> 
      </Page>
   )
}

export default Sobre;